/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  LogFilter,
  LogFilter$Outbound,
  LogFilter$outboundSchema,
} from "./logfilter.js";

export const TypesToInclude = {
  Mcp: "mcp",
  Local: "local",
  Skill: "skill",
} as const;
export type TypesToInclude = ClosedEnum<typeof TypesToInclude>;

/**
 * Payload for getting aggregated hooks metrics
 */
export type GetHooksSummaryPayload = {
  /**
   * Filter conditions (same as listHooksTraces)
   */
  filters?: Array<LogFilter> | undefined;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
  /**
   * Hook types to include (mcp, local, skill). If empty, includes all types.
   */
  typesToInclude?: Array<TypesToInclude> | undefined;
};

/** @internal */
export const TypesToInclude$outboundSchema: z.ZodMiniEnum<
  typeof TypesToInclude
> = z.enum(TypesToInclude);

/** @internal */
export type GetHooksSummaryPayload$Outbound = {
  filters?: Array<LogFilter$Outbound> | undefined;
  from: string;
  to: string;
  types_to_include?: Array<string> | undefined;
};

/** @internal */
export const GetHooksSummaryPayload$outboundSchema: z.ZodMiniType<
  GetHooksSummaryPayload$Outbound,
  GetHooksSummaryPayload
> = z.pipe(
  z.object({
    filters: z.optional(z.array(LogFilter$outboundSchema)),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    typesToInclude: z.optional(z.array(TypesToInclude$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      typesToInclude: "types_to_include",
    });
  }),
);

export function getHooksSummaryPayloadToJSON(
  getHooksSummaryPayload: GetHooksSummaryPayload,
): string {
  return JSON.stringify(
    GetHooksSummaryPayload$outboundSchema.parse(getHooksSummaryPayload),
  );
}
